import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const lookupService = {
  getLookupRoles,
  getAllPermissions,
  getLookupUsers,
  getLookupAgents,
  getUnlinkedAgents,
  getSalesDocTypes,
  getAreaCodes,
  getItems,
  getDebtors,
  getSalesDocsLookup,
  getTaxes,
}

export async function getLookupRoles() {
  return apiHelper(API_URL).get('/lookup/roles')
}

export async function getAllPermissions() {
  return apiHelper(API_URL).get('/lookup/permissions')
}

export async function getLookupUsers() {
  return apiHelper(API_URL).get('/lookup/users')
}

export async function getLookupAgents(search) {
  const params = {}
  if (search) params['search_words[0]'] = search
  return apiHelper(API_URL).get('/agents', { params })
}

export async function getUnlinkedAgents(excludeUserUuid) {
  const params = {}
  if (excludeUserUuid) params.exclude_user_uuid = excludeUserUuid
  return apiHelper(API_URL).get('/lookup/unlinked-agents', { params })
}

export async function getSalesDocTypes() {
  return apiHelper(API_URL).get('/lookup/sales-doc-types')
}

export async function getAreaCodes() {
  return apiHelper(API_URL).get('/lookup/area-codes')
}

export async function getItems(search) {
  const params = {}
  if (search) params.search = search
  return apiHelper(API_URL).get('/lookup/items', { params })
}

/**
 * Customers, from the one endpoint that answers for them.
 *
 * This used to be /lookup/debtors, which took no permission, applied no
 * client-group visibility, and returned a hardcoded first 500 accounts by
 * number. So an agent restricted to their own groups on the phone could pick
 * any customer at all from a desktop sales document. /clients is the endpoint
 * the mobile app already asks; both now see the same book under the same
 * rules.
 *
 * `size` is generous by default because two screens read this list to turn an
 * account number into a name; a typed search passes a small one.
 */
export async function getDebtors(search, size = 1000) {
  const params = { page: 1, size }
  if (search) params['search_words[0]'] = search
  return apiHelper(API_URL).get('/clients', { params })
}

export async function getSalesDocsLookup(type) {
  return apiHelper(API_URL).get('/lookup/sales-docs', { params: { type } })
}

export async function getTaxes() {
  return apiHelper(API_URL).get('/lookup/taxes')
}
